import { render, staticRenderFns } from "./ServiceAppRow.vue?vue&type=template&id=972285a2&scoped=true&"
import script from "./ServiceAppRow.vue?vue&type=script&lang=js&"
export * from "./ServiceAppRow.vue?vue&type=script&lang=js&"
import style0 from "./ServiceAppRow.vue?vue&type=style&index=0&id=972285a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972285a2",
  null
  
)

export default component.exports